module.exports = __webpack_public_path__ + "img/trial3-2.7d04d9e8.png";